module.exports = __webpack_public_path__ + "static/media/ilus-services-brand-identity.4f16be0c.svg";